module.exports = __webpack_public_path__ + "img/VMWare.3de17392.png";